export default __webpack_public_path__ + "static/media/saarland_light.fd8840b0.png";